import { render } from "./SqCalcForm.vue?vue&type=template&id=738a572e&ts=true"
import script from "./SqCalcForm.vue?vue&type=script&lang=ts"
export * from "./SqCalcForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__